export const enum CharacterLimit {
  NAME = 50,
  SHORT_NAME = 30,
  ADDRESS = 100,
  CITY = 50,
  EMAIL = 45
}
